const Form050EN = {
    stepName: {
        statement: "重要事項",
        application: "申請詳情",
        confirmation: "確認",
    },
    errorMsg: {
        date: {
            afterThisDate: "請選擇入職本校日期之後的日期",
        },
        needOne: "必須填寫“幼稚園名稱”或“幼兒中心名稱”",
        amount: {
            min: "請輸入一個有效的數值",
            min1: "數值必需大於1",
            max2: "數值最多必2位數",
            max: "數值最多必3位數",
            max4: "數值最多必4位數",
            maxDecimal: "數值最多為小數後3位",
        },
        sumTest: {
            yAndz: "欄位Y與Z相加的數值必須大於0",
            velocity: "檢測點1至檢測點9相加的數值必須大於0",
            ventilationAir: "每小時最低通氣量與量度的通氣量相加的數值必須大於0",
            ventilationAir2:
                "每小時最低通氣量與量度的通氣量相加的數值必須大於0",
            freshAir: "每小時最低鮮風量與量度的鮮風量相加的數值必須大於0",
        },
    },
    label: {
        // from Form-50
        note1: "幼兒中心內空氣調節裝置及照明標準",
        note2: "1. 幼兒活動範圍內的空氣調節系統",
        note3: "設計標準",

        note4_1: "(i) 戶外環境：夏天",
        note4_2: "33°C db",
        note4_3: "66% RH",
        note4_4: "冬天",
        note4_5: "10°C db",
        note4_6: "40% RH",

        note5_1: "(ii) 室內環境：夏天",
        note5_2: "25.5°C db",
        note5_3: "54% RH",
        note5_4: "冬天",
        note5_5: "20°C db",

        note6_1: "(iii) 鮮風量：",
        note6_2:
            "每人每秒10 公升如用窗口機或分體式空調機, 必須另置獨立的鮮風提供系統, 以符合上述的規定",
        note6_3: "每人每秒10 公升",
        note6_4:
            "如用窗口機或分體式空調機, 必須另置獨立的鮮風提供系統, 以符合上述的規定",

        note5: "2. 幼兒活動範圍內的噪音水平  ",
        note6: "幼兒活動範圍內的噪音水平不可超過其原來背景噪音4dBA",

        note7: "3. 機械抽風裝置的換氣率",
        note8_1: "盥洗室/廁所:",
        note8_2: "每小時15次換氣",
        note8_3: "廚房：",
        note8_4: "每小時15次換氣(一般性抽風, 不包括廚房抽煙機(罩))",
        note8_5: "洗衣房：",
        note8_6: "每小時15次換氣",

        note9: "4. 照明",
        note10: "在離地0.5米處量度, 幼兒活動範圍內的平均照明度須有300 lux",

        note11: "幼兒中心內空氣調節裝置的技術性資料一覽表",
        note12: "甲. 設計階段",

        note12_1: "(1) 必須提交空氣調節及機械通風裝置的詳細設計圖則。",
        note12_2: "(2) 必須列明每個房間的名稱及用途。",
        note12_3:
            "(3) 必須列明在指定的房間及與其相連而沒有牆壁分隔的地方的總使用人數(包括職員、家長與幼兒)。",
        note12_4: "(4) 必須標示冷氣機的位置及制冷量。",
        note12_5: "(5) 必須標示每台通風扇的位置及運作模式 (抽入或排出)。",
        note12_6: "(6) 必須詳列每台通風扇的大小及送風量 (公升/秒)。",
        note12_7:
            "(7) 必須提供每處幼兒通常使用的地方 (例如課室、活動室、幼兒廁所等)的鮮風供應量及換氣率的計算記錄, 以表明該裝置符合幼兒中心的有關標準和規定。",
        note12_8: "(8) 必須標示風槽/百葉孔/格柵的鮮風供應/排氣量。",
        note12_9: "(9) 鮮風/排氣風槽應預留裝置以便日後測試風量。",

        note13_1: "乙. 申請實地檢查階段",
        note13_2:
            "在提出派員作實地檢查之前, 必須完成整個空氣調節及機械通風裝置的安裝及測試, 而且需提交裝置的測試報告, 計算記錄及標示有甲(1)至(9) (如適用) 之資料的竣工圖則。",

        infoTitle: "個人資料收集聲明",
        info_1_header: "收集個人資料的目的",
        info_1: "1. 你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        info_1_a:
            "(a) 就通風量度報告/鮮風量度報告(幼兒中心/幼兒園適用)，辦理有關處理、核實及值證的事務；",
        info_1_b:
            "(b) 就上文(a)項所述的處理、核實及值證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
        info_1_c:
            "(c) 為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
        info_1_d:
            "(d) 辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        info_1_e:
            "(e) 辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
        info_1_f: "(f) 辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
        info_1_g:
            "(g) 辦理有關施行及強制執行規則及規例 [包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 [即《幼兒服務規例》(香港法例第243A章)]的事務 ",
        info_2: "2.	你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",
        info_3_header: "可獲轉移資料者",
        info_3: "3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        info_3_a:
            "(a) 政府其他政策局及部門，包括機電工程署，消防處，建築署以用於上文第1段所述的用途； ",
        info_3_b: "(b) 與本表格相關的學校，以用於上文第1段所述的用途；",
        info_3_c: "(c) 你曾就披露個人資料給予訂明同意；以及",
        info_3_d: "(d) 根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        info_4_header: "查閱個人資料",
        info_4: "4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 <a href='mailto:jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。",

        certify: "本人已閱讀、明白及同意上述條款及細則。",

        iamStatement: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",

        // from Form-49
        note: "重要事項",
        basicInfor: "幼稚園名稱",

        // from Form 50
        basicInfo: "基本資料",
        agency: "中心名稱",
        address: "地址",

        location: "位置",
        type: "評估項目的種類",
        y: "Y (米)",
        x: "X (米)",
        z: "Z (米)",

        rmVolume: "房間體積(立方米)",
        noOfPerson: "房間人數",

        measureAirVelocity: "檢測點的量度風速 (見圖A) (米/秒)",
        p1: "1",
        p2: "2",
        p3: "3",
        p4: "4",
        p5: "5",
        p6: "6",
        p7: "7",
        p8: "8",
        p9: "9",
        mean: "平均速度",
        minVent: "每小時換氣 15次所需的最低通氣量(升/秒)",
        measuredVent: "量度的通氣量(升/秒)",
        minFresh: "所需的最低鮮氣量為10升/秒/人 (升/秒)",
        measuredFresh: "量度的鮮風量 (升/秒)",

        ventTable: "通風量度表",
        freshAirTable: "鮮風量度表",
        attachment: "附件",
        attachmentLabel: "請提供承辦商簽發的報告正本",
    },
    noteValue: [
        {
            text: "「BEd(ECE)」：持有幼兒教育學士學位或同等學歷的合格幼稚園教師／幼兒工作員",
        },
        {
            text: "「C(ECE)」：持有幼兒教育證書或同等學歷的合格幼稚園教師／幼兒工作員",
        },
        { text: "「QKT」：合格幼稚園教師" },
        { text: "「CCW」：幼兒工作員" },
        {
            text: "「Pursuing C(ECE)」：正在修讀幼兒教育證書或同等學歷的課程的合格幼稚園教師／幼兒工作員／持有檢定教員註冊編號／有效准用教員編號的敎師",
        },
    ],
    workingHoursValue: {
        "AM+PM": "上午+下午",
        AM: "上午",
        PM: "下午",
    },
    whetherValue: {
        Y: "是",
        N: "否",
    },
    qualificationValue: {
        "BEd(ECE)":
            "持有幼兒教育學士學位或同等學歷的合格幼稚園教師／幼兒工作員",
        "C(ECE)": "持有幼兒教育證書或同等學歷的合格幼稚園教師／幼兒工作員",
        QKT: "合格幼稚園教師",
        CCW: "幼兒工作員",
        "Pursuing C(ECE)":
            "正在修讀幼兒教育證書或同等學歷的課程的合格幼稚園教師／幼兒工作員／持有檢定教員註冊編號／有效准用教員編號的敎師",
    },
    responsibleValue: {
        kg: "育嬰園",
        ccc: "幼兒園",
    },
    tips: {
        tip1: "量度值的總和(米/秒) ÷ 檢測點數目",
        tip2: "房間體積(立方米) x 15 + 3600 x 1000",
        tip3: "平均速度(米/秒) x Y(米) x Z(米) x 1000 x 通風口的利用系數",
        tip2b: "人數 x 10 (升/秒)",
    },
    demMultiTable: {
        field1: "欄位一",
        field2: "欄位二",
        field3: "欄位三",
        field4: "欄位四",
        field5: "欄位五",
        field6: "欄位六",
        field7: "欄位七",
        field8: "欄位八",
        field9: "欄位九",
    },
};
export default Form050EN;
